import {dateTime} from "services/date";
import {Conversation} from "../../../types/Conversation";

/**
 * Transform the given conversation by deserializing object properties
 *
 * @internal
 * @param conversation
 */
export default function deserializeConversation(conversation: any): Conversation {
    conversation.created_at = dateTime(conversation.created_at)
    conversation.updated_at = dateTime(conversation.updated_at)

    return conversation;
}